module.exports = __webpack_public_path__ + "static/media/BankDetailEdit.a85e5e6e.svg";